module.exports = __webpack_public_path__ + "static/media/gz2h1.f75027e3.png";